export default __webpack_public_path__ + "static/media/page15.10413019.jpg";